"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubjectCategoryContextProvider = exports.default = void 0;
exports.useSubjectCategoriesForLocale = useSubjectCategoriesForLocale;
const react_1 = require("react");
const build_context_1 = __importDefault(require("~/components/jsx-helpers/build-context"));
const language_1 = __importDefault(require("~/contexts/language"));
const react_intl_1 = require("react-intl");
const cms_fetch_1 = __importDefault(require("~/helpers/cms-fetch"));
function dataToEntry(item) {
    const name = item.name;
    const value = name.toLowerCase().replace(' ', '-').normalize('NFD').replace(/\p{Diacritic}/gu, '');
    return {
        value,
        cms: name,
        html: name,
        title: item.seo_title,
        icon: item.subject_icon,
        color: item.subject_color
    };
}
function useContextValue() {
    const { language } = (0, language_1.default)();
    return useSubjectCategoriesForLocale(language);
}
function useSubjectCategoriesForLocale(locale) {
    const [value, setValue] = (0, react_1.useState)([]);
    const intl = (0, react_intl_1.useIntl)();
    (0, react_1.useEffect)(() => {
        const viewAllEntry = { value: 'view-all', cms: '', html: intl.formatMessage({ id: 'viewAll' }) };
        // Empty the language-incompatible entries right away
        setValue([]);
        (0, cms_fetch_1.default)(`snippets/subjects?format=json&locale=${locale}`)
            .then((data) => data.map(dataToEntry))
            .then((data) => [viewAllEntry, ...data])
            .then(setValue);
    }, [locale, intl]);
    return value;
}
const { useContext, ContextProvider } = (0, build_context_1.default)({ useContextValue });
exports.default = useContext;
exports.SubjectCategoryContextProvider = ContextProvider;
